<template>
  <div class="container lms-wrapper">
    
    <student-nav />

    <div class="lms-content buddy-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-20">
          <div class="d-flex align-items-center">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminDashboard' }" class="tx-11" style="color: #444">Onboarding хөтөлбөр</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">Дашбоард</li>
              </ol>
            </nav>
          </div>

          <div v-if="dashboard.rdy">
            <div class="check-outer check-tree-col wd-100p">
              <div v-for="(m, i) in modules" :class="`tx-white mg-b-10 check-item pd-x-40 pd-y-20`" >
                <div class="text-center tx-semibold tx-16 mg-b-10 check-title">{{ m.title }}</div>
                
                <vc-donut
                :sections="[
                  {
                    value: m.perc,
                    color: 'white',
                  },
                ]"
                :background="bgColors[i]"
                :foreground="borderColors[i]"
                :size="80"
                unit="%"
                :thickness="12"
                :total="100"
                :start-angle="0"
              >
                <div class="tx-semibold">
                  <div class="tx-lg-28 tx-md-20 tx-sm-16 tx-xs-14 tx-white">
                    {{m.perc.toFixed(1)}}%
                  </div>
                  <div class="tx-lg-16 tx-md-14 tx-sm-12 tx-xs-8 tx-color-04">{{m.done}}/{{ m.all }}</div>
                </div>
              </vc-donut>
                <div @click="dashboardDetail(m)" role="button" style="left: 50%; transform: translate(-50%, 0%); border-radius: 30px;" class="text-center chk-more pos-absolute b-30 bg-white-1 tx-16 tx-semibold pd-x-40 pd-y-10">Дэлгэрэнгүй</div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="tx-semibold tx-18">Хамгийн өндөр эргэцтэй нэгж</div>
                <div class="bg-white rounded-20 mg-t-10">
                  <div v-for="(d, di) in dashboard.obj.homeTopReflectiveDeparts" :class="`d-flex ${di<dashboard.obj.homeTopReflectiveDeparts.length-1?'bd-b':''} pd-x-15 pd-y-10 tx-semibold align-items-center`">
                    <div class="bg-light mg-r-10 rounded-circle wd-40 ht-40 d-flex align-items-center justify-content-center"
                    style="min-width: 40px;">
                      {{d.progress.toFixed(0)}}<sup>%</sup>
                    </div>
                    <div class="tx-16 lh-1">{{ d.departName }}</div>
                    <div class="mg-l-auto tx-16">{{d.count}}/{{ d.allCount }}</div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="tx-semibold tx-18">Үндсэн ажилтан</div>

                <div :class="`tx-white mg-y-10 check-item pd-x-40 pd-y-30 rounded-20`" 
                style="background: linear-gradient(135.15deg, #FD709A 2.15%, #E43055 65.39%, #F26E7A 98.4%); height: 305px;"
                >
                
                <vc-donut
                :sections="[
                  {
                    value: dashboard.obj.homeNewbieToMainProgress.progress,
                    color: 'white',
                  },
                ]"
                :background="bgColors[3]"
                :foreground="borderColors[3]"
                :size="50"
                unit="%"
                :thickness="12"
                :total="100"
                :start-angle="0"
              >
                <div class="tx-semibold">
                  <div class="tx-lg-28 tx-md-20 tx-sm-16 tx-xs-14 tx-white">
                    {{dashboard.obj.homeNewbieToMainProgress.progress.toFixed(1)}}%
                  </div>
                  <div class="tx-lg-16 tx-md-14 tx-sm-12 tx-xs-8 tx-gray-200">
                    {{dashboard.obj.homeNewbieToMainProgress.count}}/
                    {{ dashboard.obj.homeNewbieToMainProgress.allCount }}
                  </div>
                </div>
              </vc-donut>

                <div @click="$router.push({name: 'buddyAdminDashboardDetail', params: { mode: 2 } })" role="button" style="left: 50%; transform: translate(-50%, 0%); border-radius: 30px;" class="text-center pos-absolute b-40 bg-white-1 tx-16 tx-semibold pd-x-40 pd-y-10">Дэлгэрэнгүй</div>
              </div>
              </div>
            </div>
          </div>

        </div>
      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyAdminDashboard'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>




    
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    cardBuddy: () => ({
      component: import( "@/views/modules/lms/student/buddy/components/cardBuddy.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      modules:[
        // {title: 'Шинэ ажилтан', perc: 21, all: 2512, done: 615 },
        // {title: 'Ажлаас гарсан ажилтны тоо /Туршилт/', perc: 21, all: 2512, done: 615 },
        // {title: 'Халамжлах дуудлага', perc: 21, all: 2512, done: 615 },
      ],
      bgColors:[
        '#9627DD', '#3AC37A', '#12A0A1','#e04a69', 
      ],
      borderColors:[
        '#CD81FF', '#57DA95', '#32BBBC', '#E63459', 
      ],
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      dashboard: {
        obj:{},
        rdy: false
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    dashboardDetail(m){
      switch(m.title.toLowerCase()){
        case 'шинэ ажилтан':
          this.$router.push({name: 'buddyAdminReport' }); break;
        case 'ажлаас гарсан ажилтны тоо /туршилт/':
          this.$router.push({name: 'buddyAdminDashboardDetail', params: { mode: 1 } }); break;
        case 'халамжлах дуудлага':
          this.$router.push({name: 'buddyAdminDashboardCalltocare' }); break;
        default: break;
      }
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/admin/HomeDashboardData" },
        // data: { },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.dashboard.obj= res.data;
          this.setModules(res.data);
          this.dashboard.rdy= true;
          console.log('res HomeDashboardData', res);
        }
      });
    },
    setModules(obj) {
      //this.modules=[];
      this.modules.push({title: 'Шинэ ажилтан', 
        perc: obj.homeNewbieWorkingProgress.progress, 
        all: obj.homeNewbieWorkingProgress.allCount, 
        done: obj.homeNewbieWorkingProgress.count 
      });

      this.modules.push({title: 'Ажлаас гарсан ажилтны тоо /Туршилт/', 
        perc: obj.homeNewbieFiredProgress.progress, 
        all: obj.homeNewbieFiredProgress.allCount, 
        done: obj.homeNewbieFiredProgress.count 
      });

      this.modules.push({title: 'Халамжлах дуудлага', 
        perc: obj.homeDefaultCheckProgress.progress, 
        all: obj.homeDefaultCheckProgress.allCount, 
        done: obj.homeDefaultCheckProgress.count 
      });
    },
  },
};
</script>